document.addEventListener("DOMContentLoaded", function () {
  const tabContainers = document.querySelectorAll(".egon-product-tabs");

  tabContainers.forEach(function (container) {
    const tabs = container.querySelectorAll(".tab-link");
    const panels = container.querySelectorAll(".tab-content");

    // Desktop tab behavior
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        const targetId = tab.getAttribute("aria-controls");
        const targetPanel = container.querySelector(`#${targetId}`);

        tabs.forEach(function (btn) {
          btn.classList.remove("active");
          btn.setAttribute("aria-selected", "false");
        });

        panels.forEach(function (panel) {
          panel.classList.remove("active");
          panel.hidden = true;
        });

        tab.classList.add("active");
        tab.setAttribute("aria-selected", "true");

        if (targetPanel) {
          targetPanel.classList.add("active");
          targetPanel.hidden = false;
        }
      });
    });
  });
});
